import { AutocompleteChangeReason, Box } from '@mui/material';
import { Classification } from '@synergy/models';
import { Field, FieldProps, FormikProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { PaloField } from '@synergy/components-palo';
import { SyntheticEvent } from 'react';

import { ClassificationAutocomplete } from '../../../../../common/components/classification-autocomplete/classification-autocomplete';
import {
    PurchaseOrderDetailOverviewFormValues,
    purchaseOrderDetailOverviewFieldNames as fieldNames,
} from '../models/purchase-order-detail-form-values';

export const PaloOverviewSectionClassification = () => {
    const handleClassificationChange =
        (formikProps: FormikProps<PurchaseOrderDetailOverviewFormValues>) =>
        (_event: SyntheticEvent, values: Classification[], reason: AutocompleteChangeReason) => {
            if (reason === 'clear') {
                formikProps.setFieldValue(fieldNames.classifications, []);
            } else {
                formikProps.setFieldValue(fieldNames.classifications, values);
            }
        };

    return (
        <Field name={fieldNames.classifications}>
            {({ field, form }: FieldProps<Classification[]>) => (
                <PaloField
                    label={<FormattedMessage id="app.header.classification" />}
                    name={field.name}
                    area="classification"
                >
                    {/* One line like the rest of the head (#2251): one chip, cut
                        with an ellipsis and named in full on hover, and "+1" for
                        the others. Scrolling sideways hid the names (R-178). */}
                    <Box
                        sx={{
                            '& .MuiInputBase-root': { flexWrap: 'nowrap', overflow: 'hidden' },
                            '& .MuiChip-root': { minWidth: 0, maxWidth: 'calc(100% - 48px)' },
                            // Room for the chip rather than for the typing, until the
                            // field is focused to type into it.
                            '& .MuiChip-root ~ .MuiAutocomplete-input:not(:focus)': { minWidth: '24px', flexGrow: 0 },
                            '& .MuiAutocomplete-tag': { flexShrink: 0 },
                        }}
                    >
                        <ClassificationAutocomplete
                            value={field.value}
                            onChange={handleClassificationChange(form)}
                            limitTags={1}
                        />
                    </Box>
                </PaloField>
            )}
        </Field>
    );
};
